module.exports = __webpack_public_path__ + "img/744.50dabb5b.jpg";